import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import type { LucideIcon } from 'lucide-react'

export function SettingsSection(props: {
  title?: string
  description?: string
  icon?: LucideIcon
  children: ReactNode
  variant?: 'default' | 'danger'
  className?: string
  compact?: boolean
}) {
  const Icon = props.icon
  const padding = props.compact ? 'px-4 py-3' : 'px-5 py-4'
  const contentPadding = props.compact ? 'p-4' : 'p-5'

  return (
    <div className={cn('rounded-xl border bg-card', props.className)}>
      {props.title && (
        <div className={padding}>
          <div className="flex items-center gap-2">
            {Icon && (
              <div
                className={cn(
                  'flex size-7 items-center justify-center rounded-lg',
                  props.variant === 'danger' ? 'bg-destructive/10 text-destructive' : 'bg-primary/10 text-primary',
                )}
              >
                <Icon className="size-3.5" />
              </div>
            )}
            <div>
              <h3 className="text-sm font-semibold">{props.title}</h3>
              {props.description && <p className="text-muted-foreground text-xs">{props.description}</p>}
            </div>
          </div>
        </div>
      )}
      <div className={contentPadding}>{props.children}</div>
    </div>
  )
}
